import { HelpBlockData, ElementType } from "./helpTypes";

import img1 from "../images/Kuva_1.png";
import img2 from "../images/Kuva_2_updated.png";
import img2_2 from "../images/Kuva_2_2.png";
import img2_3 from "../images/Kuva_2_3.png";
import img3_2 from "../images/Kuva_3_2.png";
import img3_3 from "../images/Kuva_3_3.png";
import img4_3 from "../images/Kuva_4_3.png";
import img5_3 from "../images/Kuva_5_3.png";
import img6_2 from "../images/Kuva_6_2.png";
import img6_5 from "../images/Kuva_6_5.png";
import img6_6 from "../images/Kuva_6_6.png";
import img7_3 from "../images/Kuva_7_3.png";
import img8_3 from "../images/Kuva_8_3.png";
import { manualLocalizations } from '../localization/manualLocalization';

export const userManual: HelpBlockData[] = [
    {
        title: manualLocalizations.userManual.registration.registerTitle,
        elements: [
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.registration.data1,
            },
            {
                elementType: ElementType.IMAGE,
                data: img1,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.registration.data2,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.registration.data3,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.registration.data4,
            },
            {
                elementType: ElementType.IMAGE,
                data: img2,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.registration.data5,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.registration.data6,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.registration.data7,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.registration.data8,
            },
            {
                elementType: ElementType.TEXT1,
                data:manualLocalizations.userManual.registration.data9,
            },
        ]
    },
    {
        title: manualLocalizations.userManual.freeTruck.freeTruckTitle,
        elements: [
            {
                elementType: ElementType.TEXT1,
                data: manualLocalizations.userManual.freeTruck.data1,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeTruck.data2,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeTruck.data3,
            },
            {
                elementType: ElementType.IMAGE,
                data: img2_2,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeTruck.data4,
            },
            {
                elementType: ElementType.IMAGE,
                data: img2_3,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeTruck.data5,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeTruck.data6,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeTruck.data7,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeTruck.data8,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeTruck.data9,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeTruck.data10
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeTruck.data11,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeTruck.data12,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeTruck.data13,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeTruck.data14,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeTruck.data15,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeTruck.data16,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeTruck.data17,
            },
        ]
    },
    {
        title: manualLocalizations.userManual.freeUnit.freeUnitTitle,
        elements: [
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeUnit.data1,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeUnit.data2,
            },
            {
                elementType: ElementType.IMAGE,
                data: img3_2,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeUnit.data3,
            },
            {
                elementType: ElementType.IMAGE,
                data: img3_3,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeUnit.data4,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeUnit.data5,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeUnit.data6,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeUnit.data7
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeUnit.data8
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeUnit.data9
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeUnit.data10
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeUnit.data11
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeUnit.data12
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeUnit.data13
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeUnit.data14
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeUnit.data15
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.freeUnit.data16
            },
        ]
    },
    {
        id: "trucksview",
        title: manualLocalizations.userManual.trucksView.trucksViewTitle,
        elements: [
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data1
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data2
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data3
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data4
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data5
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data6
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data7
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data8
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data9
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data10
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data11
            },            
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data12
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data13
            },
            {
                elementType: ElementType.IMAGE,
                data: img4_3,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data14
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data15
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data16
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data17
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data18
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data19
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data20
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data21
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data22
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data23
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data24
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data25
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data26
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data27
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data28
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.trucksView.data29
            }
        ]
    },
    {
        id: "unitsview",
        title: manualLocalizations.userManual.unitsView.unitsViewTitle,
        elements: [
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data1
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data2
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data3
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data4
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data5
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data6
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data7
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data8
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data9
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data10
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data11
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data12
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data13
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data14
            },
            {
                elementType: ElementType.IMAGE,
                data: img5_3,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data15
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data16
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data17
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data18
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data19
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data20
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data21
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data22
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data23
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data24
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data25
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data26
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.unitsView.data27
            }
        ]
    },
    {
        id: "mapview",
        title: manualLocalizations.userManual.mapView.mapViewTitle,
        elements: [
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.mapView.data1
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.mapView.data2
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.mapView.data3
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.mapView.data4
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.mapView.data5
            },
            {
                elementType: ElementType.IMAGE,
                data: img6_2,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.mapView.data6
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.mapView.data7
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.mapView.data8
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.mapView.data9
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.mapView.data10
            },
            {
                elementType: ElementType.IMAGE,
                data: img6_5,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.mapView.data11
            },
            {
                elementType: ElementType.IMAGE,
                data: img6_6,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.mapView.data12
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.mapView.data13
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.mapView.data14
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.mapView.data15
            },
        ]
    },
    {
        title: manualLocalizations.userManual.editTrucks.editTrucksTitle,
        elements: [
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editTrucks.data1
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editTrucks.data2
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editTrucks.data3
            },
            {
                elementType: ElementType.IMAGE,
                data: img7_3,
            },
            {
                elementType: ElementType.HEADER1,
                data: manualLocalizations.userManual.editTrucks.data4
            },
            {
                elementType: ElementType.TEXT1,
                data: manualLocalizations.userManual.editTrucks.data5
            },
            {
                elementType: ElementType.HEADER1,
                data: manualLocalizations.userManual.editTrucks.data6
            },
            {
                elementType: ElementType.TEXT1,
                data: manualLocalizations.userManual.editTrucks.data7
            },
            {
                elementType: ElementType.HEADER1,
                data: manualLocalizations.userManual.editTrucks.data8
            },
            {
                elementType: ElementType.TEXT1,
                data: manualLocalizations.userManual.editTrucks.data9
            },
            {
                elementType: ElementType.HEADER1,
                data: manualLocalizations.userManual.editTrucks.data10
            },
            {
                elementType: ElementType.TEXT1,
                data: manualLocalizations.userManual.editTrucks.data11
            },
            {
                elementType: ElementType.HEADER1,
                data: manualLocalizations.userManual.editTrucks.data12
            },
            {
                elementType: ElementType.TEXT1,
                data: manualLocalizations.userManual.editTrucks.data13
            },
            {
                elementType: ElementType.HEADER1,
                data: manualLocalizations.userManual.editTrucks.data14
            },
            {
                elementType: ElementType.TEXT1,
                data: manualLocalizations.userManual.editTrucks.data15
            },
        ]
    },
    {
        title: manualLocalizations.userManual.editUnits.editUnitsTitle,
        elements: [
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editUnits.data1
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editUnits.data2
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editUnits.data3
            },
            {
                elementType: ElementType.IMAGE,
                data: img8_3,
            },
            {
                elementType: ElementType.HEADER1,
                data: manualLocalizations.userManual.editUnits.data4
            },
            {
                elementType: ElementType.TEXT1,
                data: manualLocalizations.userManual.editUnits.data5
            },
            {
                elementType: ElementType.HEADER1,
                data: manualLocalizations.userManual.editUnits.data6
            },
            {
                elementType: ElementType.TEXT1,
                data: manualLocalizations.userManual.editUnits.data7
            },
            {
                elementType: ElementType.HEADER1,
                data: manualLocalizations.userManual.editUnits.data8
            },
            {
                elementType: ElementType.TEXT1,
                data: manualLocalizations.userManual.editUnits.data9
            },
            {
                elementType: ElementType.HEADER1,
                data: manualLocalizations.userManual.editUnits.data10
            },
            {
                elementType: ElementType.TEXT1,
                data: manualLocalizations.userManual.editUnits.data11
            },
            {
                elementType: ElementType.HEADER1,
                data: manualLocalizations.userManual.editUnits.data12
            },
            {
                elementType: ElementType.TEXT1,
                data: manualLocalizations.userManual.editUnits.data13
            },
            {
                elementType: ElementType.HEADER1,
                data: manualLocalizations.userManual.editUnits.data14
            },
            {
                elementType: ElementType.TEXT1,
                data: manualLocalizations.userManual.editUnits.data15
            },
        ]
    },
    {
        title: manualLocalizations.userManual.editPersonalInfo.editPersonalInfoTitle,
        elements: [
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editPersonalInfo.data1
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editPersonalInfo.data2
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editPersonalInfo.data3
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editPersonalInfo.data4
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editPersonalInfo.data5
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editPersonalInfo.data6
            },
        ]
    },
    {
        title: manualLocalizations.userManual.editCompanyInfo.editCompanyInfoTitle,
        elements: [
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editCompanyInfo.data1
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editCompanyInfo.data2
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editCompanyInfo.data3
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editCompanyInfo.data4
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editCompanyInfo.data5
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editCompanyInfo.data6
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editCompanyInfo.data7
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editCompanyInfo.data8
            },
        ]
    },
    {
        title: manualLocalizations.userManual.editFilters.editFiltersTitle,
        elements: [
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editFilters.data1
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.editFilters.data2
            },
        ]
    },
    {
        title: manualLocalizations.userManual.getWidget.getWidgetTitle,
        elements: [
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.getWidget.data1
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.getWidget.data2
            },
        ]
    },
    {
        title: manualLocalizations.userManual.changePassword.changePasswordTitle,
        elements: [
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.changePassword.data1
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.changePassword.data2
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.changePassword.data3
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.changePassword.data4
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.changePassword.data5
            },
        ]
    },
    {
        title: manualLocalizations.userManual.visibility.visibilityTitle,
        elements: [
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.visibility.data1
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.visibility.data2
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.visibility.data3
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.visibility.data4
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.userManual.visibility.data5
            },
        ]
    },
];




// WEBPACK FOOTER //
// ./src/help/userManual.ts